/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section3_P2Inputs */

const en_privacy_section3_p2 = /** @type {(inputs: Privacy_Section3_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can clear this data at any time by clearing your browser's site data for purejson.org.`)
};

const ko_privacy_section3_p2 = /** @type {(inputs: Privacy_Section3_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브라우저의 purejson.org 사이트 데이터를 삭제하면 언제든지 이 데이터를 지울 수 있습니다.`)
};

const ja_privacy_section3_p2 = /** @type {(inputs: Privacy_Section3_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザのpurejson.orgのサイトデータを削除することで、いつでもこのデータを消去できます。`)
};

/**
* | output |
* | --- |
* | "You can clear this data at any time by clearing your browser's site data for purejson.org." |
*
* @param {Privacy_Section3_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const privacy_section3_p2 = /** @type {((inputs?: Privacy_Section3_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section3_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_section3_p2(inputs)
	if (locale === "ko") return ko_privacy_section3_p2(inputs)
	return ja_privacy_section3_p2(inputs)
});